import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { TableList } from 'components';

import { IEditableColumn } from './EditableColumn.types';

import './EditableColumn.styles.scss';

const { Text } = Typography;

const Button = TableList.Button;

const EditableColumn = ({ value, editButtonText = 'form.button.change', onClick, className = '' }: IEditableColumn) => {
  const { t } = useTranslation();

  return (
    <div className={`np-editable-column ${className}`}>
      <Text>{value}</Text>
      <Button onClick={onClick}>{t(editButtonText)}</Button>
    </div>
  );
};

export default EditableColumn;
